<template>
  <!-- 风险评估 -->
  <div class="page_box">
    <div class="page_option_box">
      <div class="option_box">
        <input
          type="file"
          id="riskFile"
          accept=".doc,.docx,.xls,.xlsx,.pdf,.ppt"
          @change="fileImportOne($event)"
        />
        <input
          type="file"
          id="riskFileInfo"
          accept=".doc,.docx,.xls,.xlsx,.pdf,.ppt"
          @change="fileImportOneInfo($event)"
        />
        <el-button
          type="primary"
          plain
          icon="el-icon-bottom-right"
          size="mini"
          @click="selectFileImport"
          >导入</el-button
        >&nbsp;
        <el-button
          type="primary"
          plain
          icon="el-icon-bottom-right"
          size="mini"
          @click="selectFileImportInfo"
          >台账导入</el-button
        >&nbsp;
        <el-button
          type="primary"
          plain
          icon="el-icon-circle-plus-outline"
          size="mini"
          @click="addClick"
          >新增</el-button
        >
        <!-- <el-button
          type="primary"
          plain
          icon="el-icon-top-right"
          size="mini"
          :disabled="riskAssessmentData.dataList.length == 0"
          @click="selectFileExport"
          >导出</el-button
        > -->
        <el-button
          type="primary"
          plain
          icon="el-icon-download"
          size="mini"
          @click="$Common.fileDownloads('files/20200511/风险模板.xlsx')"
          >下载模版</el-button
        >
        <el-button
          type="danger"
          plain
          icon="el-icon-circle-close"
          size="mini"
          @click="delectAll"
          >全部删除</el-button
        >
        <el-button
          type="primary"
          plain
          icon="el-icon-setting"
          size="mini"
          @click="resetNum"
          >重置风险点编号</el-button
        >
      </div>
      <div class="search_box">
        <el-select
          v-model="riskAssessmentRequest.riskTypeId"
          placeholder="请选择风险清单"
          @change="selectRiskCate()"
          size="mini"
        >
          <el-option label="全部风险清单" value=""> </el-option>
          <el-option
            v-for="item in riskCateDataList"
            :key="item.id"
            :label="item.typeName"
            :value="item.id"
          >
            {{ item.typeName }}
          </el-option>
        </el-select>
        <!-- <el-button
          type="primary"
          icon="el-icon-search"
          size="mini"
          plain
          @click="riskAssessmentSearch"
          >搜索</el-button
        > -->
      </div>
    </div>
    <div class="page_table_box">
      <div class="school_table_box">
        <el-table
          v-loading="tableLoading"
          element-loading-text="加载中..."
          element-loading-spinner="el-icon-loading"
          :data="riskAssessmentData.dataList"
          height="100%"
          border
          class="table_box content-box"
          :span-method="arraySpanMethod"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
        >
          <el-table-column label="序号" width="70" align="center">
            {{ riskAssessmentRequest.pageNum }}
          </el-table-column>
          <el-table-column
            prop="riskTypeName"
            label="风险类型"
            show-overflow-tooltip
            width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="subjectName"
            label="风险点编号"
            show-overflow-tooltip
            width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="inspectTarget"
            label="检查对象"
            show-overflow-tooltip
            width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="potentialRisk"
            label="潜在风险"
            width="240"
            align="center"
          >
            <template slot-scope="scope">
              <el-link
                :underline="false"
                type="primary"
                @click="getRiskAssessmentInfo(scope.row)"
                >{{ scope.row.potentialRisk }}</el-link
              >
            </template>
          </el-table-column>
          <el-table-column prop="faultType" label="事故类型" align="center">
          </el-table-column>
          <el-table-column
            prop="riskLevel"
            label="风险等级"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              <div
                v-if="!scope.row.isEdit"
                @click="assessTypeClick(scope.row)"
                class="assess-type-box"
                :class="
                  $store.state.select.riskLevel[scope.row.riskLevel].className
                "
              >
                {{
                  $store.state.select.riskLevel[scope.row.riskLevel]
                    .levelNameTwo
                }}
              </div>
              <el-select
                v-else
                :style="
                  'background-color:' +
                    $store.state.select.riskLevel[scope.row.riskLevel]
                      .backgroundColor
                "
                v-model="scope.row.riskLevel"
                placeholder="请选择风险等级"
                @change="
                  riskLevelChange(
                    scope.row.inspectTarget,
                    scope.row.riskLevel,
                    scope.row.assessType
                  )
                "
                size="mini"
              >
                <el-option
                  v-for="(item, index) in riskLevel"
                  :key="index"
                  :label="item.levelNameOne"
                  :value="item.idIndex"
                >
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            prop="state"
            label="审核状态"
            show-overflow-tooltip
            width="160"
            align="center"
          >
            <template slot-scope="scope">
              {{
                $Common.getDataName(
                  $store.state.select.examineState,
                  scope.row.state
                )
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="accidentType"
            label="操作"
            width="180"
            align="center"
          >
            <template slot-scope="scope">
              <el-link
                v-show="scope.row.state == 0"
                type="primary"
                @click="openRiskAuditOne(scope.row)"
                :underline="false"
                >风险审核</el-link
              >
              <el-link
                v-show="scope.row.state >= 1"
                type="primary"
                @click="openExamineDetails(scope.row.id)"
                :underline="false"
                >审核详情</el-link
              ><el-divider direction="vertical"></el-divider>
              <el-link
                type="primary"
                @click="deleteRow(scope.row.id)"
                :underline="false"
                >删除</el-link
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination_box">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="riskAssessmentRequest.pageNum"
          :page-size="riskAssessmentRequest.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="riskAssessmentData.total"
        >
        </el-pagination>
      </div>

      <!-- 编辑风险评估 -->
      <el-dialog
        title="风险评估"
        :visible.sync="editRiskAudit"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        custom-class="showBoxContentTwo"
      >
        <div class="row height100">
          <div class="col-sm-12 check_object_right">
            <form class="form-horizontal">
              <div class="form-group">
                <label class="col-sm-12 control-label textLeft"
                  >安全风险辨识</label
                >
              </div>
              <div class="form-group">
                <div class="col-sm-2 control-label">
                  风险点名称
                </div>
                <div class="col-sm-10">
                  <input
                    type="text"
                    class="form-control"
                    v-model="editRiskAssessmentData.riskName"
                  />
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-2 control-label">
                  风险所属区域
                </div>
                <div class="col-sm-10">
                  <input
                    type="text"
                    class="form-control"
                    v-model="editRiskAssessmentData.riskArea"
                  />
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-2 control-label">
                  检查对象
                </div>
                <div class="col-sm-10">
                  <input
                    type="text"
                    class="form-control"
                    v-model="editRiskAssessmentData.inspectTarget"
                    disabled
                  />
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-2 control-label">
                  风险描述
                </div>
                <div class="col-sm-10">
                  <input
                    type="text"
                    class="form-control"
                    v-model="editRiskAssessmentData.potentialRisk"
                    disabled
                  />
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-2 control-label">
                  事故类型
                </div>
                <div class="col-sm-10">
                  <input
                    type="text"
                    class="form-control"
                    v-model="editRiskAssessmentData.faultType"
                    disabled
                  />
                </div>
              </div>
              <!-- 风险矩阵法（LS） -->
              <div
                v-show="editRiskAssessmentData.assessType == 0"
                class="assessmentBox"
              >
                <div class="form-group">
                  <label class="col-sm-12 control-label textLeft"
                    >风险矩阵法（LS）</label
                  >
                </div>
                <div class="form-group">
                  <div class="col-sm-2 control-label">
                    L(可能性)
                  </div>
                  <div class="col-sm-10">
                    <select
                      class="form-control"
                      v-model="editRiskAssessmentData.lsL"
                      @change="editCalculateVaR"
                    >
                      <option
                        v-for="value in this.$store.state.select
                          .assessmentMethod[0].lsl"
                        :key="value.fraction"
                        :value="value.fraction"
                        >{{ value.name }}</option
                      >
                    </select>
                  </div>
                </div>
                <div class="form-group">
                  <div class="col-sm-2 control-label">
                    S(严重性)
                  </div>
                  <div class="col-sm-10">
                    <select
                      class="form-control"
                      v-model="editRiskAssessmentData.lsS"
                      @change="editCalculateVaR"
                    >
                      <option
                        v-for="value in this.$store.state.select
                          .assessmentMethod[0].lss"
                        :key="value.fraction"
                        :value="value.fraction"
                        >{{ value.name }}</option
                      >
                    </select>
                  </div>
                </div>
                <div class="form-group">
                  <div class="col-sm-2 control-label"></div>
                  <div class="col-sm-10">
                    风险值：<span>{{ editRiskAssessmentData.riskValue }}</span>
                    风险等级：<span>{{
                      this.$store.state.select.riskLevel[
                        editRiskAssessmentData.riskLevel
                      ].levelNameOne
                    }}</span>
                    安全色：
                    <span
                      class="riskColorBlock"
                      :class="
                        this.$store.state.select.riskLevel[
                          editRiskAssessmentData.riskLevel
                        ].className
                      "
                    ></span>
                  </div>
                </div>
              </div>
              <!-- 分析评价法-LEC -->
              <div
                v-show="editRiskAssessmentData.assessType == 1"
                class="assessmentBox"
              >
                <div class="form-group">
                  <label class="col-sm-12 control-label textLeft"
                    >分析评价法-LEC</label
                  >
                </div>
                <div class="form-group">
                  <div class="col-sm-2 control-label">
                    L(可能性)
                  </div>
                  <div class="col-sm-10">
                    <select
                      class="form-control"
                      v-model="editRiskAssessmentData.lecL"
                      @change="editCalculateVaR"
                    >
                      <option
                        v-for="value in this.$store.state.select
                          .assessmentMethod[1].lecl"
                        :key="value.fraction"
                        :value="value.fraction"
                        >{{ value.name }}</option
                      >
                    </select>
                  </div>
                </div>
                <div class="form-group">
                  <div class="col-sm-2 control-label">
                    E(频繁程度)
                  </div>
                  <div class="col-sm-10">
                    <select
                      class="form-control"
                      v-model="editRiskAssessmentData.lecE"
                      @change="editCalculateVaR"
                    >
                      <option
                        v-for="value in this.$store.state.select
                          .assessmentMethod[1].lece"
                        :key="value.fraction"
                        :value="value.fraction"
                        >{{ value.name }}</option
                      >
                    </select>
                  </div>
                </div>
                <div class="form-group">
                  <div class="col-sm-2 control-label">
                    C(严重性)
                  </div>
                  <div class="col-sm-10">
                    <select
                      class="form-control"
                      v-model="editRiskAssessmentData.lecC"
                      @change="editCalculateVaR"
                    >
                      <option
                        v-for="value in this.$store.state.select
                          .assessmentMethod[1].lecc"
                        :key="value.fraction"
                        :value="value.fraction"
                        >{{ value.name }}</option
                      >
                    </select>
                  </div>
                </div>
                <div class="form-group">
                  <div class="col-sm-2 control-label"></div>
                  <div class="col-sm-10">
                    风险值：<span>{{ editRiskAssessmentData.riskValue }}</span>
                    风险等级：<span>{{
                      this.$store.state.select.riskLevel[
                        editRiskAssessmentData.riskLevel
                      ].levelNameOne
                    }}</span>
                    安全色：<span
                      class="riskColorBlock"
                      :class="
                        this.$store.state.select.riskLevel[
                          editRiskAssessmentData.riskLevel
                        ].className
                      "
                    ></span>
                  </div>
                </div>
              </div>

              <!-- 管控层级 -->
              <div class="form-group">
                <div class="col-sm-2 control-label">
                  管控层级
                </div>
                <div class="col-sm-10">
                  <select
                    class="form-control"
                    v-model="editRiskAssessmentData.manageLevel"
                  >
                    <option
                      v-for="value in this.$store.state.select.controlLevel"
                      :key="value.id"
                      :value="value.id"
                      >{{ value.name }}</option
                    >
                  </select>
                </div>
              </div>

              <div class="form-group">
                <div class="col-sm-2 control-label">
                  检查频次
                </div>
                <div class="col-sm-10">
                  <select
                    class="form-control"
                    v-model="editRiskAssessmentData.checkFrequency"
                  >
                    <option
                      v-for="value in this.$store.state.select
                        .inspectionFrequency"
                      :key="value.id"
                      :value="value.id"
                      >{{ value.name }}</option
                    >
                  </select>
                </div>
              </div>

              <div class="form-group">
                <div class="col-sm-2 control-label">
                  责任部门
                </div>
                <div class="col-sm-10">
                  <select
                    class="form-control"
                    v-model="editRiskAssessmentData.manageDepartmentId"
                  >
                    <option
                      v-for="value in schoolDepartmentList"
                      :key="value.departmentId"
                      :value="value.departmentId"
                      >{{ value.departmentName }}</option
                    >
                  </select>
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-2 control-label">
                  责任人
                </div>
                <div class="col-sm-10">
                  <input
                    type="text"
                    class="form-control"
                    v-model="editRiskAssessmentData.manager"
                  />
                </div>
              </div>

              <div class="form-group">
                <div class="col-sm-2 control-label">
                  电话
                </div>
                <div class="col-sm-10">
                  <input
                    type="text"
                    class="form-control"
                    v-model="editRiskAssessmentData.managerPhone"
                  />
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-12 control-label textLeft">建议措施</label>
              </div>

              <div class="form-group">
                <div class="col-sm-2 control-label">
                  科学技术
                </div>
                <div class="col-sm-10">
                  <input
                    type="text"
                    class="form-control"
                    v-model="editRiskAssessmentData.technology"
                  />
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-2 control-label">
                  管理措施
                </div>
                <div class="col-sm-10">
                  <input
                    type="text"
                    class="form-control"
                    v-model="editRiskAssessmentData.measures"
                  />
                </div>
              </div>

              <div class="form-group">
                <div class="col-sm-2 control-label">
                  培训教育
                </div>
                <div class="col-sm-10">
                  <input
                    type="text"
                    class="form-control"
                    v-model="editRiskAssessmentData.education"
                  />
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-2 control-label">
                  个体防护
                </div>
                <div class="col-sm-10">
                  <input
                    type="text"
                    class="form-control"
                    v-model="editRiskAssessmentData.protection"
                  />
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-2 control-label">
                  应急处置
                </div>
                <div class="col-sm-10">
                  <input
                    type="text"
                    class="form-control"
                    maxlength="10"
                    v-model="editRiskAssessmentData.disposal"
                  />
                </div>
              </div>
            </form>
          </div>

          <div class="col-sm-12 check_object_bottom">
            <el-button
              type="primary"
              size="mini"
              @click="setRiskAssessmentInfo()"
              >确定</el-button
            >
            <el-button
              type="primary"
              size="mini"
              plain
              @click="editRiskAudit = false"
              >取消</el-button
            >
          </div>
        </div>
      </el-dialog>

      <!-- 风险评估审核 -->
      <el-dialog
        title="风险评估审核"
        :visible.sync="riskAudit"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        custom-class="showBoxContentTwo"
      >
        <div class="row height100">
          <div class="col-sm-12 check_object_right">
            <form class="form-horizontal">
              <div class="form-group">
                <label class="col-sm-4 control-label textLeft">审核项目</label>
                <label class="col-sm-2 control-label textLeft">是否符合</label>
                <label class="col-sm-6 control-label textLeft"
                  >不符合原因</label
                >
              </div>
              <div class="form-group">
                <div class="col-sm-5 control-label textLeft">
                  <span>1</span> 措施的可行性和有效性
                </div>
                <div class="col-sm-2">
                  <select
                    class="form-control"
                    v-model="
                      editAssessmentRiskExamineData.auditInfoList[0].isSuitable
                    "
                  >
                    <option :value="0">是</option>
                    <option :value="1">否</option>
                  </select>
                </div>
                <div class="col-sm-5">
                  <input
                    type="text"
                    class="form-control"
                    v-model="
                      editAssessmentRiskExamineData.auditInfoList[0].remarks
                    "
                  />
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-5 control-label textLeft">
                  <span>2</span> 是否是风险减低到可容许水平
                </div>
                <div class="col-sm-2">
                  <select
                    class="form-control"
                    v-model="
                      editAssessmentRiskExamineData.auditInfoList[1].isSuitable
                    "
                  >
                    <option :value="0">是</option>
                    <option :value="1">否</option>
                  </select>
                </div>
                <div class="col-sm-5">
                  <input
                    type="text"
                    class="form-control"
                    v-model="
                      editAssessmentRiskExamineData.auditInfoList[1].remarks
                    "
                  />
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-5 control-label textLeft">
                  <span>3</span> 是否产生新的危险有害因素
                </div>
                <div class="col-sm-2">
                  <select
                    class="form-control"
                    v-model="
                      editAssessmentRiskExamineData.auditInfoList[2].isSuitable
                    "
                  >
                    <option :value="0">是</option>
                    <option :value="1">否</option>
                  </select>
                </div>
                <div class="col-sm-5">
                  <input
                    type="text"
                    class="form-control"
                    v-model="
                      editAssessmentRiskExamineData.auditInfoList[2].remarks
                    "
                  />
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-5 control-label textLeft">
                  <span>4</span> 是否已选定了最新的解决方案
                </div>
                <div class="col-sm-2">
                  <select
                    class="form-control"
                    v-model="
                      editAssessmentRiskExamineData.auditInfoList[3].isSuitable
                    "
                  >
                    <option :value="0">是</option>
                    <option :value="1">否</option>
                  </select>
                </div>
                <div class="col-sm-5">
                  <input
                    type="text"
                    class="form-control"
                    v-model="
                      editAssessmentRiskExamineData.auditInfoList[3].remarks
                    "
                  />
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-5 control-label textLeft">
                  <span>5</span> 是否会被应用于实际工作中
                </div>
                <div class="col-sm-2">
                  <select
                    class="form-control"
                    v-model="
                      editAssessmentRiskExamineData.auditInfoList[4].isSuitable
                    "
                  >
                    <option :value="0">是</option>
                    <option :value="1">否</option>
                  </select>
                </div>
                <div class="col-sm-5">
                  <input
                    type="text"
                    class="form-control"
                    v-model="
                      editAssessmentRiskExamineData.auditInfoList[4].remarks
                    "
                  />
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-2 control-label">
                  建议
                </div>
                <div class="col-sm-10">
                  <select
                    class="form-control"
                    v-model="
                      editAssessmentRiskExamineData.riskModelSchool.state
                    "
                  >
                    <option :value="1">审核通过</option>
                    <option :value="2">审核不通过</option>
                  </select>
                </div>
              </div>
              <div
                v-show="
                  editAssessmentRiskExamineData.riskModelSchool.state == 2
                "
                class="assessmentBox"
              >
                <!-- 风险矩阵法（LS） -->
                <div
                  v-show="
                    editAssessmentRiskExamineData.riskModelSchool.assessType ==
                      0
                  "
                >
                  <div class="form-group">
                    <label class="col-sm-12 control-label textLeft"
                      >风险矩阵法（LS）</label
                    >
                  </div>
                  <div class="form-group">
                    <div class="col-sm-2 control-label">
                      L(可能性)
                    </div>
                    <div class="col-sm-10">
                      <select
                        class="form-control"
                        v-model="
                          editAssessmentRiskExamineData.riskModelSchool.lsL
                        "
                        @change="calculateVaR"
                      >
                        <option
                          v-for="value in this.$store.state.select
                            .assessmentMethod[0].lsl"
                          :key="value.fraction"
                          :value="value.fraction"
                          >{{ value.name }}</option
                        >
                      </select>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="col-sm-2 control-label">
                      S(严重性)
                    </div>
                    <div class="col-sm-10">
                      <select
                        class="form-control"
                        v-model="
                          editAssessmentRiskExamineData.riskModelSchool.lsS
                        "
                        @change="calculateVaR"
                      >
                        <option
                          v-for="value in this.$store.state.select
                            .assessmentMethod[0].lss"
                          :key="value.fraction"
                          :value="value.fraction"
                          >{{ value.name }}</option
                        >
                      </select>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="col-sm-2 control-label"></div>
                    <div class="col-sm-10">
                      风险值：<span>{{
                        editAssessmentRiskExamineData.riskModelSchool.riskValue
                      }}</span>
                      风险等级：<span>{{
                        this.$store.state.select.riskLevel[
                          editAssessmentRiskExamineData.riskModelSchool
                            .riskLevel
                        ].levelNameOne
                      }}</span>
                      安全色：
                      <!-- <span class="riskColorBlock" style="background-color:{{this.$store.state.select.riskLevel[editAssessmentRiskExamineData.riskModelSchool.riskLevel].backgroundColor}}">

                                        </span> -->
                      <span
                        class="riskColorBlock"
                        :class="
                          this.$store.state.select.riskLevel[
                            editAssessmentRiskExamineData.riskModelSchool
                              .riskLevel
                          ].className
                        "
                      ></span>
                    </div>
                  </div>
                </div>

                <!-- 分析评价法-LEC -->
                <div
                  v-show="
                    editAssessmentRiskExamineData.riskModelSchool.assessType ==
                      1
                  "
                >
                  <div class="form-group">
                    <label class="col-sm-12 control-label textLeft"
                      >分析评价法-LEC</label
                    >
                  </div>
                  <div class="form-group">
                    <div class="col-sm-2 control-label">
                      L(可能性)
                    </div>
                    <div class="col-sm-10">
                      <select
                        class="form-control"
                        v-model="
                          editAssessmentRiskExamineData.riskModelSchool.lecL
                        "
                        @change="calculateVaR"
                      >
                        <option
                          v-for="value in this.$store.state.select
                            .assessmentMethod[1].lecl"
                          :key="value.fraction"
                          :value="value.fraction"
                          >{{ value.name }}</option
                        >
                      </select>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="col-sm-2 control-label">
                      E(频繁程度)
                    </div>
                    <div class="col-sm-10">
                      <select
                        class="form-control"
                        v-model="
                          editAssessmentRiskExamineData.riskModelSchool.lecE
                        "
                        @change="calculateVaR"
                      >
                        <option
                          v-for="value in this.$store.state.select
                            .assessmentMethod[1].lece"
                          :key="value.fraction"
                          :value="value.fraction"
                          >{{ value.name }}</option
                        >
                      </select>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="col-sm-2 control-label">
                      C(严重性)
                    </div>
                    <div class="col-sm-10">
                      <select
                        class="form-control"
                        v-model="
                          editAssessmentRiskExamineData.riskModelSchool.lecC
                        "
                        @change="calculateVaR"
                      >
                        <option
                          v-for="value in this.$store.state.select
                            .assessmentMethod[1].lecc"
                          :key="value.fraction"
                          :value="value.fraction"
                          >{{ value.name }}</option
                        >
                      </select>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="col-sm-2 control-label"></div>
                    <div class="col-sm-10">
                      风险值：<span>{{
                        editAssessmentRiskExamineData.riskModelSchool.riskValue
                      }}</span>
                      风险等级：<span>{{
                        this.$store.state.select.riskLevel[
                          editAssessmentRiskExamineData.riskModelSchool
                            .riskLevel
                        ].levelNameOne
                      }}</span>
                      安全色：<span
                        class="riskColorBlock"
                        :class="
                          this.$store.state.select.riskLevel[
                            editAssessmentRiskExamineData.riskModelSchool
                              .riskLevel
                          ].className
                        "
                      ></span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-2 control-label">
                  责任人
                </div>
                <div class="col-sm-10">
                  <input
                    type="text"
                    class="form-control"
                    maxlength="10"
                    v-model="
                      editAssessmentRiskExamineData.riskModelSchool.manager
                    "
                  />
                </div>
              </div>
            </form>
          </div>

          <div class="col-sm-12 check_object_bottom">
            <el-button
              type="primary"
              size="mini"
              @click="setRiskAssessmentExamineInfo"
              >确定</el-button
            >
            <el-button type="primary" size="mini" plain @click="cancelRiskAudit"
              >取消</el-button
            >
          </div>
        </div>
      </el-dialog>

      <!-- 风险评估审核详情 -->
      <el-dialog
        title="风险评估审核详情"
        :visible.sync="examineDetails"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        custom-class="showBoxContentTwo"
      >
        <div class="row height100">
          <div class="col-sm-12 check_object_right">
            <form class="form-horizontal">
              <div class="form-group">
                <label class="col-sm-4 control-label textLeft">审核项目</label>
                <label class="col-sm-2 control-label textLeft">是否符合</label>
                <label class="col-sm-6 control-label textLeft"
                  >不符合原因</label
                >
              </div>
              <div class="form-group">
                <div class="col-sm-5 control-label textLeft">
                  <span>1</span> 措施的可行性和有效性
                </div>
                <div class="col-sm-2">
                  <select
                    class="form-control"
                    disabled
                    v-model="riskAssessmentdetails.auditInfoList[0].isSuitable"
                  >
                    <option :value="0">是</option>
                    <option :value="1">否</option>
                  </select>
                </div>
                <div class="col-sm-5">
                  <input
                    type="text"
                    class="form-control"
                    disabled
                    v-model="riskAssessmentdetails.auditInfoList[0].remarks"
                  />
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-5 control-label textLeft">
                  <span>2</span> 是否是风险减低到可容许水平
                </div>
                <div class="col-sm-2">
                  <select
                    class="form-control"
                    disabled
                    v-model="riskAssessmentdetails.auditInfoList[1].isSuitable"
                  >
                    <option :value="0">是</option>
                    <option :value="1">否</option>
                  </select>
                </div>
                <div class="col-sm-5">
                  <input
                    type="text"
                    disabled
                    class="form-control"
                    v-model="riskAssessmentdetails.auditInfoList[1].remarks"
                  />
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-5 control-label textLeft">
                  <span>3</span> 是否产生新的危险有害因素
                </div>
                <div class="col-sm-2">
                  <select
                    class="form-control"
                    disabled
                    v-model="riskAssessmentdetails.auditInfoList[2].isSuitable"
                  >
                    <option :value="0">是</option>
                    <option :value="1">否</option>
                  </select>
                </div>
                <div class="col-sm-5">
                  <input
                    type="text"
                    disabled
                    class="form-control"
                    v-model="riskAssessmentdetails.auditInfoList[2].remarks"
                  />
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-5 control-label textLeft">
                  <span>4</span> 是否已选定了最新的解决方案
                </div>
                <div class="col-sm-2">
                  <select
                    class="form-control"
                    disabled
                    v-model="riskAssessmentdetails.auditInfoList[3].isSuitable"
                  >
                    <option :value="0">是</option>
                    <option :value="1">否</option>
                  </select>
                </div>
                <div class="col-sm-5">
                  <input
                    type="text"
                    disabled
                    class="form-control"
                    v-model="riskAssessmentdetails.auditInfoList[3].remarks"
                  />
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-5 control-label textLeft">
                  <span>5</span> 是否会被应用于实际工作中
                </div>
                <div class="col-sm-2">
                  <select
                    class="form-control"
                    disabled
                    v-model="riskAssessmentdetails.auditInfoList[4].isSuitable"
                  >
                    <option :value="0">是</option>
                    <option :value="1">否</option>
                  </select>
                </div>
                <div class="col-sm-5">
                  <input
                    type="text"
                    disabled
                    class="form-control"
                    v-model="riskAssessmentdetails.auditInfoList[4].remarks"
                  />
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-2 control-label">
                  建议
                </div>
                <div class="col-sm-10">
                  <select
                    class="form-control"
                    disabled
                    v-model="riskAssessmentdetails.riskModelSchool.state"
                  >
                    <option :value="1">审核通过</option>
                    <option :value="2">审核不通过</option>
                  </select>
                </div>
              </div>
              <div
                v-show="riskAssessmentdetails.riskModelSchool.state == 2"
                class="assessmentBox"
              >
                <!-- 风险矩阵法（LS） -->
                <div
                  v-show="riskAssessmentdetails.riskModelSchool.assessType == 0"
                >
                  <div class="form-group">
                    <label class="col-sm-12 control-label textLeft"
                      >风险矩阵法（LS）</label
                    >
                  </div>
                  <div class="form-group">
                    <div class="col-sm-2 control-label">
                      L(可能性)
                    </div>
                    <div class="col-sm-10">
                      <input
                        type="text"
                        disabled
                        class="form-control"
                        v-model="
                          this.$store.state.select.assessmentMethod[0].lsl[
                            riskAssessmentdetails.riskModelSchool.lsL
                          ].name
                        "
                      />
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="col-sm-2 control-label">
                      S(严重性)
                    </div>
                    <div class="col-sm-10">
                      <input
                        type="text"
                        disabled
                        class="form-control"
                        v-model="
                          this.$store.state.select.assessmentMethod[0].lss[
                            riskAssessmentdetails.riskModelSchool.lsS
                          ].name
                        "
                      />
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="col-sm-2 control-label"></div>
                    <div class="col-sm-10">
                      风险值：<span>{{
                        riskAssessmentdetails.riskModelSchool.riskValue
                      }}</span>
                      风险等级：<span>{{
                        this.$store.state.select.riskLevel[
                          riskAssessmentdetails.riskModelSchool.riskLevel
                        ].levelNameOne
                      }}</span>
                      安全色：

                      <span
                        class="riskColorBlock"
                        :class="
                          this.$store.state.select.riskLevel[
                            riskAssessmentdetails.riskModelSchool.riskLevel
                          ].className
                        "
                      ></span>
                    </div>
                  </div>
                </div>

                <!-- 分析评价法-LEC -->
                <div
                  v-show="riskAssessmentdetails.riskModelSchool.assessType == 1"
                >
                  <div class="form-group">
                    <label class="col-sm-12 control-label textLeft"
                      >分析评价法-LEC</label
                    >
                  </div>
                  <div class="form-group">
                    <div class="col-sm-2 control-label">
                      L(可能性)
                    </div>
                    <div class="col-sm-10">
                      <select
                        class="form-control"
                        v-model="riskAssessmentdetails.riskModelSchool.lecL"
                        @change="calculateVaR"
                      >
                        <option
                          v-for="value in this.$store.state.select
                            .assessmentMethod[1].lecl"
                          :key="value.fraction"
                          :value="value.fraction"
                          >{{ value.name }}</option
                        >
                      </select>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="col-sm-2 control-label">
                      E(频繁程度)
                    </div>
                    <div class="col-sm-10">
                      <select
                        class="form-control"
                        v-model="riskAssessmentdetails.riskModelSchool.lecE"
                        @change="calculateVaR"
                      >
                        <option
                          v-for="value in this.$store.state.select
                            .assessmentMethod[1].lece"
                          :key="value.fraction"
                          :value="value.fraction"
                          >{{ value.name }}</option
                        >
                      </select>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="col-sm-2 control-label">
                      C(严重性)
                    </div>
                    <div class="col-sm-10">
                      <select
                        class="form-control"
                        v-model="riskAssessmentdetails.riskModelSchool.lecC"
                        @change="calculateVaR"
                      >
                        <option
                          v-for="value in this.$store.state.select
                            .assessmentMethod[1].lecc"
                          :key="value.fraction"
                          :value="value.fraction"
                          >{{ value.name }}</option
                        >
                      </select>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="col-sm-2 control-label"></div>
                    <div class="col-sm-10">
                      风险值：<span>{{
                        riskAssessmentdetails.riskModelSchool.riskValue
                      }}</span>
                      风险等级：<span>{{
                        this.$store.state.select.riskLevel[
                          riskAssessmentdetails.riskModelSchool.riskLevel
                        ].levelNameOne
                      }}</span>
                      安全色：<span
                        class="riskColorBlock"
                        :class="
                          this.$store.state.select.riskLevel[
                            riskAssessmentdetails.riskModelSchool.riskLevel
                          ].className
                        "
                      ></span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-2 control-label">
                  责任人
                </div>
                <div class="col-sm-10">
                  <input
                    type="text"
                    disabled
                    class="form-control"
                    v-model="riskAssessmentdetails.riskModelSchool.manager"
                  />
                </div>
              </div>
            </form>
          </div>

          <div class="col-sm-12 check_object_bottom">
            <el-button
              type="primary"
              size="mini"
              plain
              @click="examineDetails = false"
              >返回</el-button
            >
          </div>
        </div>
      </el-dialog>
      <rike-assessment-dialog
        :showDialog="aShowDialog"
        @close="aClose"
      ></rike-assessment-dialog>
    </div>
  </div>
</template>

<script>
import RikeAssessmentDialog from "./components/RikeAssessmentDialog.vue";
export default {
  name: "RiskAssessment",
  components: {
    RikeAssessmentDialog
  },
  props: {},
  data() {
    return {
      // 风险评估审核详情
      examineDetails: false,
      // 风险评估审核Box
      riskAudit: false,
      // 编辑风险评估显示
      editRiskAudit: false,
      // 风险清单类型
      riskCateDataList: [],
      // 获取风险评估请求数据
      riskAssessmentRequest: {
        pageNum: 1, // 当前页
        pageSize: 1, // 每页显示几条数据
        schoolId: this.$store.state.schoolId,
        riskTypeId: ""
      },
      // 风险评估数据
      riskAssessmentData: {
        pageNum: 1, // 当前页
        pageSize: 20, // 每页显示几条数据
        pages: 1,
        total: 0,
        dataList: []
      },
      // 编辑风险评估
      editRiskAssessmentData: {
        id: 0, // 编号
        riskName: "", //  风险点名称
        riskArea: "", // 风险所属区域
        subjectName: "", // 项目名称
        inspectTarget: "", // 检查对象
        potentialRisk: "", // 潜在风险
        riskLevel: 0, // 风险等级 0低风险(IV级) 1一般风险(III级) 2较大风险(II级) 3重大风险(I级)
        faultType: "", // 事故类型
        state: "", // 风险状态 0未审核 1审核通过 2已重新评定
        assessType: "", // 评估类型 0风险矩阵法（LS） 1教学条件危险性分析评价法（LEC）
        lsL: 0, // 风险矩阵法可能性
        lsS: 0, // 风险矩阵法严重性
        lecL: 0, // 分析评价法可能性
        lecE: 0, // 分析评价法频繁程度
        lecC: 0, // 分析评价法严重性
        riskValue: 0, // 风险值(L*S)/(L*E*C)
        manageLevel: 0, // 管控级别 0请选择 1校(园)级 2副校(园)级 3处级(科级、科室级、处科级) 4岗位责任人(责任人)
        manageDepartmentId: 0, // 责任部门id
        manager: "", // 责任人
        managerPhone: "", // 责任人手机号
        checkFrequency: 0, // 检查频次 0每日1次 1每周1次 2半月1次 3每月1次
        technology: "", // 科学技术
        measures: "", // 管理措施
        education: "", // 培训教育
        protection: "", // 个体防护
        disposal: "" // 应急处置
      },
      riskIdentificationDataPage: 1,
      // 学校部门列表
      schoolDepartmentList: [],
      // 当前风险类型
      // thisRiskCate: 0,

      // 编辑风险评估审核
      editAssessmentRiskExamineData: {
        // 风险模板审核信息
        auditInfoList: [
          { isSuitable: 0, auditingSubject: 0, id: 1, remarks: "" },
          { isSuitable: 0, auditingSubject: 1, id: 2, remarks: "" },
          { isSuitable: 0, auditingSubject: 2, id: 3, remarks: "" },
          { isSuitable: 0, auditingSubject: 3, id: 4, remarks: "" },
          { isSuitable: 1, auditingSubject: 4, id: 5, remarks: "" }
        ],
        riskModelSchool: {
          lecL: 0, //lecL分数
          lecE: 0, //lecE分数
          lecC: 0, //lecC分数
          lsL: 0, //lsL分数
          lsS: 0, //lsS分数
          riskValue: 0, // 总分数
          assessType: 1, // 评估类型
          state: 1, // 状态 审核通过或不通过
          id: 0, // 风险ID
          manager: "", // 责任人
          riskLevel: 0 // 风险等级
        }
      },

      riskAssessmentdetails: {
        // 风险模板审核信息
        auditInfoList: [
          { isSuitable: 0, auditingSubject: 0, id: 1, remarks: "" },
          { isSuitable: 0, auditingSubject: 1, id: 2, remarks: "" },
          { isSuitable: 0, auditingSubject: 2, id: 3, remarks: "" },
          { isSuitable: 0, auditingSubject: 3, id: 4, remarks: "" },
          { isSuitable: 1, auditingSubject: 4, id: 5, remarks: "" }
        ],
        riskModelSchool: {
          lecL: 0, //lecL分数
          lecE: 0, //lecE分数
          lecC: 0, //lecC分数
          lsL: 0, //lsL分数
          lsS: 0, //lsS分数
          riskValue: 0, // 总分数
          assessType: 1, // 评估类型
          state: 1, // 状态 审核通过或不通过
          id: 0, // 风险ID
          manager: "", // 责任人
          riskLevel: 0 // 风险等级
        }
      },
      tableLoading: false,
      aShowDialog: false,
      targetRow: []
    };
  },
  watch: {},
  computed: {
    riskLevel() {
      return this.$store.state.select.riskLevel;
    }
  },
  methods: {
    async resetNum() {
      let req = {
        schoolId: this.$store.state.schoolId
      };
      const loading = this.$loading({
        lock: true,
        text: "重置中,请稍等...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let res = await this.$Http.resetRiskAssessmentNum(req);
      loading.close();
      if (res.code == 200) {
        // console.log(res)
        this.getRiskEvaluationList();
        this.getRiskList();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    async openExamineDetails(id) {
      var requestParams = {
        riskModelSchoolId: id
      };
      let res = await this.$Http.getRiskAssessmentExamineInfo(requestParams);
      if (res.code == 200) {
        // console.log(res)
        this.riskAssessmentdetails.riskModelSchool = res.data.riskModelSchool;
        this.riskAssessmentdetails.auditInfoList = res.data.auditInfoList;
        this.examineDetails = true;
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 提交风险评估审核信息
    async setRiskAssessmentExamineInfo() {
      let res = await this.$Http.setRiskAssessmentExamineInfo(
        this.editAssessmentRiskExamineData
      );
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "信息提交成功"
        });
        this.getRiskEvaluationList();
        this.cancelRiskAudit();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 取消风险评估审核
    cancelRiskAudit() {
      this.riskAudit = false;
    },
    // 风险审核计算风险值（危险指数）
    calculateVaR() {
      // 风险值
      let sumValue = 0;
      if (this.editAssessmentRiskExamineData.riskModelSchool.assessType == 0) {
        // LS计算
        sumValue =
          this.editAssessmentRiskExamineData.riskModelSchool.lsL *
          this.editAssessmentRiskExamineData.riskModelSchool.lsS;
      } else {
        // LEC计算
        sumValue =
          this.editAssessmentRiskExamineData.riskModelSchool.lecL *
          this.editAssessmentRiskExamineData.riskModelSchool.lecE *
          this.editAssessmentRiskExamineData.riskModelSchool.lecC;
      }
      // console.log(sumValue)
      var temporaryData = {};
      for (let riskLevelValue in this.$store.state.select.riskLevel) {
        if (
          sumValue >=
          this.$store.state.select.riskLevel[riskLevelValue].hazardIndexStart
        ) {
          temporaryData = this.$store.state.select.riskLevel[riskLevelValue];
        }
      }
      // console.log()

      this.editAssessmentRiskExamineData.riskModelSchool.riskValue = sumValue;
      this.editAssessmentRiskExamineData.riskModelSchool.riskLevel =
        temporaryData.idIndex;
    },
    // 选择风险清单
    selectRiskCate(val) {
      // this.thisRiskCate = val
      // this.riskAssessmentRequest.riskTypeId = val
      this.riskAssessmentRequest.pageNum = 1;
      this.getRiskEvaluationList();
    },
    handleCurrentChange(val) {
      this.riskAssessmentRequest.pageNum = val;
      this.getRiskEvaluationList();
      console.log(`当前页: ${val}`);
    },
    // 编辑风险评估计算风险值（危险指数）
    editCalculateVaR() {
      // 风险值
      let sumValue = 0;
      if (this.editRiskAssessmentData.assessType == 0) {
        // LS计算
        sumValue =
          this.editRiskAssessmentData.lsL * this.editRiskAssessmentData.lsS;
      } else {
        // LEC计算
        sumValue =
          this.editRiskAssessmentData.lecL *
          this.editRiskAssessmentData.lecE *
          this.editRiskAssessmentData.lecC;
      }
      // console.log(sumValue)
      var temporaryData = {};
      for (let riskLevelValue in this.$store.state.select.riskLevel) {
        if (this.editRiskAssessmentData.assessType == 0) {
          console.log(
            this.$store.state.select.riskLevel[riskLevelValue]
              .lsHazardIndexStart
          );
          if (
            sumValue >=
            this.$store.state.select.riskLevel[riskLevelValue]
              .lsHazardIndexStart
          ) {
            temporaryData = this.$store.state.select.riskLevel[riskLevelValue];
          }
        } else {
          if (
            sumValue >=
            this.$store.state.select.riskLevel[riskLevelValue].hazardIndexStart
          ) {
            temporaryData = this.$store.state.select.riskLevel[riskLevelValue];
          }
        }
      }
      // console.log(temporaryData)
      this.editRiskAssessmentData.riskValue = sumValue;
      this.editRiskAssessmentData.riskLevel = temporaryData.idIndex;
    },
    // 打开风险审核
    openRiskAuditOne(thisData) {
      // console.log(thisData)
      this.riskAudit = true;
      // this.editAssessmentRiskExamineData.riskModelSchool.id = thisData.id
      // this.editAssessmentRiskExamineData.riskModelSchool.assessType = thisData.assessType

      this.editAssessmentRiskExamineData = {
        // 风险模板审核信息
        auditInfoList: [
          { isSuitable: 0, auditingSubject: 0, id: 1, remarks: "" },
          { isSuitable: 0, auditingSubject: 1, id: 2, remarks: "" },
          { isSuitable: 0, auditingSubject: 2, id: 3, remarks: "" },
          { isSuitable: 0, auditingSubject: 3, id: 4, remarks: "" },
          { isSuitable: 1, auditingSubject: 4, id: 5, remarks: "" }
        ],
        riskModelSchool: {
          lecL: 0, //lecL分数
          lecE: 0, //lecE分数
          lecC: 0, //lecC分数
          lsL: 0, //lsL分数
          lsS: 0, //lsS分数
          riskValue: 0, // 总分数
          assessType: thisData.assessType, // 评估类型
          state: 1, // 状态 审核通过或不通过
          id: thisData.id, // 风险ID
          manager: "", // 责任人
          riskLevel: 0 // 风险等级
        }
      };
      // console.log(this.editAssessmentRiskExamineData.riskModelSchool)
    },
    // 提交风险评估审核信息
    async setRiskAssessmentInfo() {
      // console.log(this.editRiskAssessmentData)
      let res = await this.$Http.setRiskAssessmentInfo(
        this.editRiskAssessmentData,
        true
      );
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "信息提交成功"
        });
        this.getRiskEvaluationList();
        this.editRiskAudit = false;
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 获取风险评估信息
    async getRiskAssessmentInfo(thisData) {
      var requestParams = {
        schoolId: this.$store.state.schoolId,
        id: thisData.id
      };
      let res = await this.$Http.getRiskAssessmentInfo(requestParams);
      if (res.code == 200) {
        // console.log(res)
        this.editRiskAssessmentData = {
          id: res.data.riskAuditInfo.id, // 编号
          riskName: res.data.riskAuditInfo.riskName, // 风险点名称
          riskArea: res.data.riskAuditInfo.riskArea, //  风险所属区域
          subjectName: res.data.riskAuditInfo.subjectName, // 项目名称
          inspectTarget: res.data.riskAuditInfo.inspectTarget, // 检查对象
          potentialRisk: res.data.riskAuditInfo.potentialRisk, // 潜在风险
          riskLevel: res.data.riskAuditInfo.riskLevel, // 风险等级 0低风险(IV级) 1一般风险(III级) 2较大风险(II级) 3重大风险(I级)
          faultType: res.data.riskAuditInfo.faultType, // 事故类型
          state: res.data.riskAuditInfo.state, // 风险状态 0未审核 1审核通过 2已重新评定
          assessType: res.data.riskAuditInfo.assessType, // 评估类型 0风险矩阵法（LS） 1教学条件危险性分析评价法（LEC）
          lsL: res.data.riskAuditInfo.lsL, // 风险矩阵法可能性
          lsS: res.data.riskAuditInfo.lsS, // 风险矩阵法严重性
          lecL: res.data.riskAuditInfo.lecL, // 分析评价法可能性
          lecE: res.data.riskAuditInfo.lecE, // 分析评价法频繁程度
          lecC: res.data.riskAuditInfo.lecC, // 分析评价法严重性
          riskValue: res.data.riskAuditInfo.riskValue, // 风险值(L*S)/(L*E*C)
          manageLevel: res.data.riskAuditInfo.manageLevel, // 管控级别 0请选择 1校(园)级 2副校(园)级 3处级(科级、科室级、处科级) 4岗位责任人(责任人)
          manageDepartmentId: res.data.riskAuditInfo.manageDepartmentId, // 责任部门id
          manager: res.data.riskAuditInfo.manager, // 责任人
          managerPhone: res.data.riskAuditInfo.managerPhone, // 责任人手机号
          checkFrequency: res.data.riskAuditInfo.checkFrequency, // 检查频次 0每日1次 1每周1次 2半月1次 3每月1次
          technology: res.data.riskAuditInfo.technology, // 科学技术
          measures: res.data.riskAuditInfo.measures, // 管理措施
          education: res.data.riskAuditInfo.education, // 培训教育
          protection: res.data.riskAuditInfo.protection, // 个体防护
          disposal: res.data.riskAuditInfo.disposal // 应急处置
        };
        this.schoolDepartmentList = res.data.departmentList;
        this.editRiskAudit = true;
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 搜索风险评估
    riskAssessmentSearch() {
      this.riskAssessmentRequest.pageNum = 1;
      this.riskAssessmentRequest.pageSize = 1;
      this.getRiskEvaluationList();
    },
    // 获取风险清单
    async getRiskList() {
      if (sessionStorage.getItem("riskCateDataList")) {
        this.riskCateDataList = sessionStorage.getItem("riskCateDataList");
      }
      let res = await this.$Http.getRiskList({
        schoolId: this.$store.state.schoolId
      });
      // console.log(res)
      if (res.code == 200) {
        this.riskCateDataList = res.data;
        sessionStorage.setItem("riskCateDataList", res.data);
      }

      // console.log(this.riskCateDataList[0].id)
    },
    // 风险评估列表
    async getRiskEvaluationList() {
      let newRequestData = {
        pageNum: this.riskAssessmentRequest.pageNum,
        pageSize: this.riskAssessmentRequest.pageSize,
        schoolId: this.riskAssessmentRequest.schoolId,
        riskTypeId: this.riskAssessmentRequest.riskTypeId
      };
      this.tableLoading = true;
      let res = await this.$Http.getRiskEvaluationList(newRequestData);
      this.tableLoading = false;
      if (res.code == 200) {
        this.riskAssessmentData.pageSize = res.data.pageSize;
        this.riskAssessmentData.pageNum = res.data.pageNum;
        this.riskAssessmentData.total = res.data.total;
        this.riskAssessmentData.pages = res.data.pages;
        let data = res.data.list || [];
        this.riskAssessmentData.dataList = data.map((item, index) => {
          item.isEdit = false;
          return item;
        });
        this.getTargetRow(data[0].riskTypeId);
      } else if (res.code == 101) {
        this.riskAssessmentData = {
          pageNum: 1, // 当前页
          pageSize: 20, // 每页显示几条数据
          pages: 1,
          total: 0,
          dataList: []
        };
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
        this.riskAssessmentData = {
          pageNum: 1, // 当前页
          pageSize: 20, // 每页显示几条数据
          pages: 1,
          total: 0,
          dataList: []
        };
      }
    },

    // 获取检查对象行数
    async getTargetRow(id) {
      let searchData = {
        schoolId: this.$store.state.schoolId,
        pageNum: this.riskAssessmentRequest.pageNum, // 第几页
        riskTypeId: id
      };
      let res = await this.$Http.getTargetRow(searchData);
      if (res.code == 200) {
        this.targetRow = res.data || [];
      } else if (res.code == 101) {
        this.targetRow = [];
      } else {
        this.targetRow = [];
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      let subjectName = row.subjectName;
      if (columnIndex == 0 || columnIndex == 1) {
        if (rowIndex == 0) {
          return [this.riskAssessmentData.dataList.length, 1];
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      } else if (
        columnIndex == 2 ||
        columnIndex == 3 ||
        columnIndex == 5 ||
        columnIndex == 6
      ) {
        if (
          this.getDataValue(subjectName) == subjectName &&
          rowIndex == this.getDataInfo(subjectName).row
        ) {
          return [this.getDataInfo(subjectName).num, 1];
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      } else {
        return {
          rowspan: 1,
          colspan: 1
        };
      }
    },
    getDataInfo(val) {
      let a = this.targetRow.find((item, index) => {
        return item.subjectName == val;
      });
      if (a) {
        return a;
      }
    },
    getDataValue(val) {
      let a = this.targetRow.find((item, index) => {
        return item.subjectName == val;
      });
      if (a) {
        return a.subjectName;
      }
    },
    // 选择文件导入
    selectFileImport() {
      document.getElementById("riskFile").click();
    },
    // 选择文件导入
    selectFileImportInfo() {
      document.getElementById("riskFileInfo").click();
    },
    // 风险评估模版导入
    async fileImportOne(event) {
      var fileUpload = event.target.files[0];
      if (!fileUpload) {
        return;
      }
      var requestData = {
        file: fileUpload
      };
      document.getElementById('riskFile').value=null

      let res = await this.$Http.importRiskAssessment(requestData, true);
      // console.log(res)
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "导入成功!"
        });
        this.getRiskEvaluationList();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 台账导入
    async fileImportOneInfo(event) {
      var fileUpload = event.target.files[0];
      if (!fileUpload) {
        return;
      }
      var requestData = {
        file: fileUpload,
        schoolId: this.$store.state.schoolId
      };
      document.getElementById("riskFileInfo").value=null;

      let res = await this.$Http.importRiskAssessmentInfo(requestData, true);
      // console.log(res)
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "导入成功!"
        });
        this.getRiskEvaluationList();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 导出
    async selectFileExport() {
      let req = {
        schoolId: this.$store.state.schoolId
      };
      this.$Common.exportData(req, "exportRiskAssessment", "风险评估");
    },
    // 全部删除
    delectAll() {
      this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.delRiskAssessment({ schoolId: this.$store.state.schoolId });
        })
        .catch(() => {});
    },
    deleteRow(id) {
      this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.delRiskAssessment({
            schoolId: this.$store.state.schoolId,
            schoolRiskModelId: id
          });
        })
        .catch(() => {});
    },
    async delRiskAssessment(info) {
      let requestData = Object.assign({}, info);
      let res = await this.$Http.delRiskAssessment(requestData);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "删除成功!"
        });
        this.getRiskEvaluationList();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    addClick() {
      this.aShowDialog = true;
    },
    aClose(isRefresh) {
      this.aShowDialog = false;
      if (isRefresh) {
        this.getRiskEvaluationList();
        this.getRiskList();
      }
    },
    async riskLevelChange(inspectTarget, riskLevel, assessType) {
      let ids = [];
      this.riskAssessmentData.dataList.forEach((item, index) => {
        if (item.inspectTarget == inspectTarget) {
          ids.push(item.id);
        }
      });
      let obj = {
        riskModelSchoolIds: ids.join(","),
        assessType: assessType,
        riskLevel: riskLevel
      };
      let res = await this.$Http.editSchoolModelLevel(obj);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "修改成功!"
        });
        this.getRiskEvaluationList();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    assessTypeClick(row) {
      row.isEdit = true;
    }
  },
  created() {},
  mounted() {
    this.getRiskEvaluationList();
    this.getRiskList();
  }
};
</script>
<style scoped lang="scss">
.assess-type-box {
  /* height: 40px; */
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.table_box {
  &.el-table--enable-row-hover {
    background-color: #fff !important;
    /deep/ tbody {
      tr:hover > td {
        background-color: #fff !important;
      }
    }
  }
  /deep/ .el-table__body {
    height: 100%;
    tr > td {
      padding: 0px;
      .cell {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        padding: 10px;

        .risk_level_one,
        .risk_level_two,
        .risk_level_three,
        .risk_level_four {
          margin: -10px;
          width: calc(100% + 20px);
          height: calc(100% + 20px);
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
  tbody {
    tr:hover > td {
      background-color: #fff !important;
    }
  }
}
</style>
